import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { supabase } from '@/lib/supabase';
import { InvitationStatus, ProjectInvite } from '@/shared/types/api';

type Props = {
  projectId: string;
  statuses?: InvitationStatus[];
};

export type ProjectMemberInviteWithOrgMember = ProjectInvite & {
  org_member: OrgMemberWithProfile;
};

export const getProjectMemberInvites = async ({
  projectId,
  statuses,
}: Props): Promise<ProjectMemberInviteWithOrgMember[]> => {
  let query = supabase
    .from('project_member_invites')
    .select(
      `
      *,
      org_member:org_members!inner(
        *,
        profile:profiles!inner(*)
      )
    `,
    )
    .eq('project_id', Number(projectId));

  if (statuses && statuses.length > 0) {
    query = query.in('status', statuses);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }
  return data;
};
